<template>
  <div class="not-found">
    <van-empty description="页面不存在" />
    <p class="countdown">{{ countdown }} 秒后自动返回首页</p>
    <van-button type="primary" round size="small" @click="goHome">
      返回首页
    </van-button>
  </div>
</template>

<script>
const COUNTDOWN_SECONDS = 10;

export default {
  name: "NotFound",
  data() {
    return {
      countdown: COUNTDOWN_SECONDS,
      timer: null,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        this.goHome();
      }
    }, 1000);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goHome() {
      this.clearTimer();
      this.$router.replace({ name: "index" });
    },
  },
};
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}

.countdown {
  margin-bottom: 16px;
  color: #999;
  font-size: 14px;
}
</style>
